import { Tooltip, styled, tooltipClasses } from '@mui/material';
import React from 'react'

const TooltipCC = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} componentsProps={{tooltip: {sx: {fontSize: '13px'}}}}/>
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));

export default TooltipCC